import * as THREE from "three";

export const COLORS = [
  // {
  //   name: "Regular",
  //   listName: "COLORS",
  //   roughnessMap: "./textures/color/regular/roughness.jpg",
  //   normalMap: "./textures/color/regular/normal.jpg",
  //   size: [0.05, 0.05, 0.05],
  //   offset: [0.5, 0.0],
  //   roughness: 1,
  //   metalness: 0,
  //   rotation: 0,
  //   space: THREE.SRGBColorSpace,
  //   envMapIntensity: 1,
  //   emissive: true,
  // },
  // {
  //   name: "Regular2",
  //   listName: "COLORS",
  //   roughnessMap: "./textures/color/regular2/roughness.jpg",
  //   normalMap: "./textures/color/regular2/normal.jpg",
  //   aoMap: "./textures/color/regular2/ao.jpg",
  //   size: [0.1, 0.1, 0.1],
  //   offset: [0.5, 0.0],
  //   roughness: 0.6,
  //   normalScale: [1, 1],
  //   metalness: 0,
  //   rotation: 0,
  //   space: THREE.SRGBColorSpace,
  //   envMapIntensity: 1,
  //   emissive: true,
  // },
  {
    name: "Regular3",
    listName: "COLORS",
    roughnessMap: "./textures/color/regular3/roughness.jpg",
    normalMap: "./textures/color/regular3/normal.jpg",
    metalnessMap: "./textures/color/regular3/metalness.jpg",
    size: [0.1, 0.1, 0.1],
    offset: [0.5, 0.0],
    roughness: 2,
    normalScale: [1, 1],
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    emissive: true,
  },
];
